module.exports = __webpack_public_path__ + "img/application-rhinestone.64104045.jpg";